// Angular + external
import { Component, OnDestroy } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";
import { BfxBlotterNewFilterActionEvent } from "../bfx-blotter-filter/bfx-blotter-filter.constants";
import { BfxBlotterFilterService } from "../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
import { BfxDialogData } from "./models/bfx-dialog-data.model";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: "bfx-dialog-find-new-favorite",
  templateUrl: "./html/bfx-dialog-find-new-favorite.html",
  standalone: false,
})
export class BfxDialogFindNewFavoriteComponent extends BfxDialogBaseComponent implements OnDestroy {
  public filterNameValid: boolean = false;
  public filterNameEmpty: boolean = true;
  private newFilterCallback: any;

  /***************************************/
  /* DATA */
  public config: any = {
    debug: true,
  };

  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      height: 150,
      title_text: "New Favourite",
      message_text_invalid: "Favourite Name is Invalid",
      autocomplete_filterName: "",
    },
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private _translationService: TranslateService,
    private _filterService: BfxBlotterFilterService,
  ) {
    super();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public openDialog(dialogData: BfxDialogData): Observable<any> {
    this.data.dialogId = dialogData.dialogId;

    let event: BfxBlotterNewFilterActionEvent = dialogData.event;
    this.data.actionEvent = event;
    this.data.payload = dialogData.payload;
    this.newFilterCallback = this.data.actionEvent._callback;

    this.data.dialogData.show = true;
    NativeDesktopSupport.prepareEmbeddedDialog(null, this._dialog, null);

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    super.closeDialog();

    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  /* COPY FILTER INTO- Actions */
  public actionCreateFilter_confirm(): void {
    if (this.filterNameValid) {
      this.newFilterCallback(this.data.dialogData.autocomplete_filterName);
      this.closeDialog();
    }
  }

  public actionCreateFilter_close(): void {
    this.closeDialog();
  }

  public helperCreateFilter_validateFilterName(event: any) {
    let data: string = event.query != null ? event.query : event;

    if (data != null && data.length == 0) {
      this.filterNameValid = false;
      this.filterNameEmpty = true;
      return;
    }
    if (data != null && data.length > 50) {
      this.filterNameValid = false;
      this.filterNameEmpty = false;
      this.data.dialogData.message_text_invalid = this._translationService.instant(
        "find.favorite.name.too.long",
      );
      return;
    }
    if (
      this.data.payload &&
      this.data.payload.favoriteNames instanceof Set &&
      this.data.payload.favoriteNames.has(data.toLowerCase())
    ) {
      this.filterNameValid = false;
      this.filterNameEmpty = false;
      this.data.dialogData.message_text_invalid = this._translationService.instant(
        "find.favorite.already.exists",
        [data],
      );
      return;
    } else {
      this.filterNameValid = true;
      this.filterNameEmpty = false;
      this.data.dialogData.autocomplete_filterName = data;
    }
  }
}
